import type { Country } from "./countries.ts";
import { phone } from "phone";

export const phonesInText = (country: string) => (x: string): string[] =>
  x
    .split("\n")
    .map((y) => phone(y, { country }))
    .filter(({ isValid }) => isValid)
    .map(({ phoneNumber }) => (phoneNumber ?? "").replace("+", ""));

const stripNonDigits = (phone: string): string => phone.replace(/\D/g, "");

const stripLeadingZeros = (digits: string): string =>
  digits.startsWith("00") ? digits.slice(2) : digits;

export const normalizePhone = (phone: string): string => {
  const digits = stripLeadingZeros(stripNonDigits(phone));
  if (/^05\d{8}$/.test(digits)) return `972${digits.slice(1)}`;
  if (/^0[23489]\d{7}$/.test(digits)) return `972${digits.slice(1)}`;
  if (/^9720[2-9]\d{7,8}$/.test(digits)) return `972${digits.slice(4)}`;
  if (/^490\d{8,11}$/.test(digits)) return `49${digits.slice(3)}`;
  return digits;
};

export const countryFromPhone = (phone?: string): Country | undefined => {
  if (!phone) return undefined;
  const normalized = normalizePhone(phone);
  if (normalized.startsWith("972")) return "Israel";
  if (normalized.startsWith("49")) return "Germany";
  if (normalized.startsWith("1")) return "USA";
  return undefined;
};

export const isPhoneLikeUserId = (userId: string): boolean =>
  /^\d{8,15}$/.test(userId);

const systemUserIds = new Set(["thread-system", "project-system"]);

export const isSystemUserId = (userId: string): boolean =>
  systemUserIds.has(userId);

export const validatePhoneWithPrefix = (phone: string): string | null => {
  const normalized = normalizePhone(phone);
  if (normalized.startsWith("0")) {
    return `Phone number must include an international country code (e.g., +972 for Israel, +1 for US). You provided: ${phone}`;
  }
  if (normalized.length < 10 || normalized.length > 15) {
    return `Phone number must be 10-15 digits with international prefix (e.g., +1, +972, +44). You provided: ${phone}`;
  }
  return null;
};
